
const defaultState = {
  loading: false,
  entries: [
    [], [], [], []
  ],
  index: 0,
  searchType: 1,
  options: [],
  summary: [],
  pathNames: [],
  editTitle: '',
  totalCount: 0,
  lawreportEntries: [],
  selectedSbt: 0,
  showNewLawreport: false,
  originalFileName: '',
  createdSbtId: -1,
  templateId: -1,
  templates: []
}

export default (state = defaultState, action) => {

  switch (action.type) {

    case 'FETCH_LAWREPORT_CATEGORIES_BEGIN':
      return { ...state, loading: true, summary: [] }
    case 'FETCH_LAWREPORT_CATEGORIES_SUCCESS':

      let entries = state.entries;

      if (action.index < 4) {
        entries[action.index] = action.payload.entries;
        entries = entries.slice(0, action.index + 1);
      }

      if(action.payload.summary){
        action.payload.summary.specialEntries.forEach(e => {
          e.special = true;
        })
      }

      return {
        ...state,
        loading: false,
        entries,
        summary: action.payload.summary ? action.payload.summary.entries.concat(action.payload.summary.specialEntries) : [],
        index: action.index,
        searchType: action.searchType,
        options: action.options
      }
    case 'FETCH_LAWREPORT_EDIT_BEGIN':
      return { ...state, loading: true, pathNames: [], editTitle: '', totalCount: 0, selectedSbt: 0, lawreportEntries: [] };
    case 'FETCH_LAWREPORT_EDIT_SUCCESS':

      if (action.payload.entries.length === 0) {
        document.location.href = '/rattsfall';
      }

      return {
        ...state,
        loading: false,
        lawreportEntries: action.payload.entries,
        pathNames: action.payload.pathNames.map((p) => p.charAt(0).toUpperCase() + p.substr(1)),
        editTitle: action.payload.title,
        totalCount: action.payload.totalCount,
        selectedSbt: action.payload.entries[0].id
      };
    case 'LAWREPORT_SELECT_SBT':
      return { ...state, selectedSbt: action.payload }
    case 'LAWREPORT_PREV_SBT':
      const prevIndex = state.lawreportEntries.findIndex((e) => e.id === state.selectedSbt) - 1;
      return { ...state, selectedSbt: prevIndex >= 0 ? state.lawreportEntries[prevIndex].id : state.selectedSbt }
    case 'LAWREPORT_NEXT_SBT':
      const nextIndex = state.lawreportEntries.findIndex((e) => e.id === state.selectedSbt) + 1;
      return { ...state, selectedSbt: nextIndex < state.lawreportEntries.length ? state.lawreportEntries[nextIndex].id : state.selectedSbt }
    case 'LAWREPORT_SHOW_NEW':
      return { ...state, showNewLawreport: true }
    case 'LAWREPORT_HIDE_NEW':
      return { ...state, showNewLawreport: false }
    case 'LAWREPORT_CHANGE_ORIGINAL_FILENAME':
      return { ...state, originalFileName: action.payload }
    case 'LAWREPORT_CHANGE_TEMPLATE_ID':
      let foundTemplate = state.templates.find(t => t.id === action.payload);
      
      return { ...state, templateId: action.payload, originalFileName:foundTemplate? foundTemplate.originalFileName : '' }
    case 'LAWREPORT_CREATE_BEGIN':
      return { ...state, loading: true }
    case 'LAWREPORT_CREATE_SUCCESS':
      return { ...state, loading: false, createdSbtId: action.payload.id }
    case 'FETCH_SBT_BEGIN':
      return { ...state, createdSbtId: -1, showNewLawreport: false, originalFileName: '' }
    case 'LAWREPORT_FIRST_SBT':
      return { ...state, selectedSbt: state.lawreportEntries[0].id }
    case 'LAWREPORT_LAST_SBT':
      return { ...state, selectedSbt: state.lawreportEntries[state.lawreportEntries.length - 1].id }
    case 'LAWREPORT_FETCH_TEMPLATES_SUCCESS':
      return { ...state, templates: [{id: -1, name:'- Blank mall -'}, ...action.payload.templates] };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/lawreport/lawReportReducers.js